var _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.08,219.16A11.82,11.82,0,0,0,368.25,231V376.41a12,12,0,0,1-16,11.29l-89.73-31.87a26,26,0,0,0-14.66-.82V231a11.83,11.83,0,0,1,11.83-11.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.27,388.41H235.87a11.92,11.92,0,0,1-4-.71l-20.79-7.31,25.85-19.9a26.17,26.17,0,0,1,25.6-4.66l89.73,31.87A11.94,11.94,0,0,0,356.27,388.41Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.44,222.63a11.74,11.74,0,0,0-8.36-3.47c-12.32,0-11.83,11.83-11.83,11.83v22.26h23.66V231A11.76,11.76,0,0,0,388.44,222.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.39,312.8S476.52,206.35,421.69,146c-48.4-53.31-125-74-187.48-30C212,131.7,195.75,162.2,169.75,171.62,140.6,182.19,103.13,186,76.06,231.26S58.71,334.69,94.8,365.65s99.25.75,156.16-1.51S426.55,444.16,456.39,312.8Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.39,312.8S476.52,206.35,421.69,146c-48.4-53.31-125-74-187.48-30C212,131.7,195.75,162.2,169.75,171.62,140.6,182.19,103.13,186,76.06,231.26S58.71,334.69,94.8,365.65s99.25.75,156.16-1.51S426.55,444.16,456.39,312.8Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelving--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.4,152h63.5a0,0,0,0,1,0,0v18.06a0,0,0,0,1,0,0H260.4a5.13,5.13,0,0,1-5.13-5.13v-7.81A5.13,5.13,0,0,1,260.4,152Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.9,129.47H264.3a9,9,0,0,0-9,9h0a9,9,0,0,0,9,9h59.6Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.32,
    y: 108.7,
    width: 21.67,
    height: 60.5,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 108.7,
    width: 21.67,
    height: 60.5,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.5,
    y: 108.7,
    width: 21.67,
    height: 60.5,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,152h63.5a0,0,0,0,1,0,0v18.06a0,0,0,0,1,0,0H260.4a5.13,5.13,0,0,1-5.13-5.13v-7.81A5.13,5.13,0,0,1,260.4,152Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.9,129.47H264.3a9,9,0,0,0-9,9h0a9,9,0,0,0,9,9h59.6Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.32,
    y: 108.7,
    width: 21.67,
    height: 60.5,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.41,
    y: 108.7,
    width: 21.67,
    height: 60.5,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.5,
    y: 108.7,
    width: 21.67,
    height: 60.5,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.26 170.82 248.08 170.82 248.08 180.9 261.89 180.9 261.89 205.9 270.11 205.9 270.11 180.9 392.22 180.9 392.22 205.9 400.44 205.9 400.44 180.9 418.26 180.9 418.26 170.82",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.26 170.82 248.08 170.82 248.08 180.9 261.89 180.9 261.89 205.9 270.11 205.9 270.11 180.9 392.22 180.9 392.22 205.9 400.44 205.9 400.44 180.9 418.26 180.9 418.26 170.82",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215,200.82a54.13,54.13,0,0,0-5.69,2.21c1-.75,2-1.51,3-2.3a143.59,143.59,0,0,0,12.87-11.65,138.79,138.79,0,0,1-15.24,12.8,33.82,33.82,0,0,0,1.95-4c1-2.52,1.19-5-1.22-6.41-3-1.66-6.55.83-5.6,5.1a15.52,15.52,0,0,0,3.26,6.43,96.69,96.69,0,0,1-10.93,6.56l-.36.18a35.14,35.14,0,0,0,2.11-4.3c1-2.52,1.2-5.05-1.21-6.41-3-1.67-6.56.82-5.6,5.1a15.5,15.5,0,0,0,3.2,6.36c-4.55,2.24-9.25,4.14-13.93,6.21l-.68.31a30.74,30.74,0,0,0,2.54-3.12c1.52-2.23,2.34-4.64.31-6.52-2.49-2.31-6.57-.72-6.64,3.66a15.8,15.8,0,0,0,1.65,7,71,71,0,0,0-12.4,7.36l-.12.09a23.77,23.77,0,0,0,1.43-2.57c1.15-2.44,1.57-5-.73-6.48a3.76,3.76,0,0,0-5.66,1.75,3.35,3.35,0,0,0-1.21-1.15c-2.32-1.34-4.6.11-6.55,2.16-.51.53-1,1.1-1.45,1.68a71.78,71.78,0,0,1,5.67-12.07,17.11,17.11,0,0,0,6.81,1.46c4.62,0,6.57-3.85,4.3-6.24-1.84-1.94-4.44-1.2-6.89.21-.81.47-1.6,1-2.34,1.54a69.38,69.38,0,0,1,8-9.9,17.37,17.37,0,0,0,6.58,3.31c4.49,1.11,7.31-2.15,5.68-5-1.32-2.33-4-2.24-6.74-1.46a33.27,33.27,0,0,0-3.76,1.39c1.22-1.19,2.49-2.34,3.77-3.47,1.69-1.44,3.43-2.83,5.2-4.18a17.38,17.38,0,0,0,6.48,3.23c4.48,1.11,7.3-2.15,5.68-5-1.32-2.33-4-2.23-6.74-1.45-.63.18-1.27.4-1.89.63,2.34-1.67,4.72-3.3,7.1-4.93l2.2-1.5a17.51,17.51,0,0,0,6.82,3.5c4.49,1.11,7.3-2.15,5.68-5-1.32-2.34-4-2.24-6.74-1.46a29,29,0,0,0-3.13,1.12h0c.46-.32.91-.65,1.36-1,.84-.6,1.66-1.21,2.48-1.84,1-.76,2-1.61,3-2.41.56-.45,1.1-.93,1.64-1.42a17.1,17.1,0,0,0,6.85,3.54c4.49,1.11,7.31-2.14,5.69-5-1.32-2.33-4-2.24-6.75-1.46a37.59,37.59,0,0,0-4.41,1.67h0c1.83-1.7,3.6-3.47,5.28-5.32.12-.13.22-.26.33-.39.73-.8,1.44-1.61,2.13-2.44s1.57-2,2.33-3a57.57,57.57,0,0,0,7.53-13.17,56.57,56.57,0,0,1-7.79,13,82,82,0,0,1-10.4,11l-.41.35a38.76,38.76,0,0,0,2.3-4.65c1-2.52,1.2-5.05-1.21-6.41-3-1.66-6.56.82-5.6,5.1a15.83,15.83,0,0,0,3.55,6.78l-.89.76c-.35.29-.71.59-1.07.87-.59.48-1.19.94-1.79,1.39l-1,.74c-.86.63-1.74,1.26-2.62,1.87L193,175l-1.44,1a36.5,36.5,0,0,0,2.21-4.47c1-2.52,1.2-5.05-1.21-6.41-3-1.67-6.56.82-5.61,5.1a15.75,15.75,0,0,0,3.4,6.59l-1.07.69-4,2.58-.77.51c-.74.48-1.47,1-2.2,1.47-.32.21-.64.42-.95.64-1,.7-2.05,1.41-3.06,2.14a38.41,38.41,0,0,0,2.25-4.54c1-2.52,1.2-5.06-1.21-6.41-3-1.67-6.56.82-5.61,5.09a15.74,15.74,0,0,0,3.47,6.68c-1.72,1.26-3.42,2.56-5.08,3.91-1.2,1-2.39,2.06-3.55,3.12a27.27,27.27,0,0,0,1.35-2.89c1-2.52,1.2-5-1.21-6.41-3-1.66-6.56.82-5.61,5.1a15.74,15.74,0,0,0,3.21,6.37,71.21,71.21,0,0,0-8.83,10.67,26.28,26.28,0,0,0,.67-3.36c.33-2.68-.06-5.2-2.72-5.93-3.28-.9-6.17,2.38-4.21,6.3a15.7,15.7,0,0,0,4.7,5.44,74,74,0,0,0-6.36,13.14,25.19,25.19,0,0,0-.29-2.86c-.45-2.66-1.53-5-4.29-4.91-3.4.06-5.24,4-2.25,7.23a15.49,15.49,0,0,0,5.7,3.76,94.89,94.89,0,0,0-2.82,10.81c-.11.58-.21,1.16-.31,1.74a2.9,2.9,0,0,0-.36.34c-.12-.5-.26-1-.42-1.49-.86-2.56-2.28-4.67-5-4.19-3.35.59-4.55,4.79-1.11,7.49a15.26,15.26,0,0,0,5.93,2.77,1.78,1.78,0,0,0,.12.29c-.37,2.75-.65,5.51-.82,8.29q-.19,3.1-.25,6.23c-2.9,0-5,3.17-2.94,6.62a14.56,14.56,0,0,0,3.18,3.77c.25,3.9.63,7.8,1.15,11.67a3.2,3.2,0,0,0-3.1-.71c-1.83.49-2.65,2-2.94,3.77a3.65,3.65,0,0,0-1,2.49c-1.36-2-2.64-4.09-3.88-6.19a17.21,17.21,0,0,0,4.62-5.4c2.18-4.07-.27-7.61-3.45-6.74-2.59.7-3.16,3.34-3.08,6.17a30.42,30.42,0,0,0,.3,3.2L131,272.84c-1.12-2-2.07-4-3.12-6.08-.27-.49-.5-1-.72-1.51a17.24,17.24,0,0,0,5.55-4.43c2.9-3.59,1.15-7.53-2.13-7.27-2.68.2-3.73,2.69-4.18,5.48a31.61,31.61,0,0,0-.33,3.68l-1-2.2a112.44,112.44,0,0,1-5-15.33,17.43,17.43,0,0,0,6.42-4c3.25-3.29,1.91-7.38-1.39-7.46-2.68-.06-4,2.31-4.71,5a36.9,36.9,0,0,0-.8,4.46c-.71-3-1.32-6-1.82-9.07-.35-1.89-.57-3.8-.81-5.71a17.21,17.21,0,0,0,7.16-3.21c3.65-2.83,2.84-7.06-.42-7.57-2.64-.41-4.24,1.77-5.32,4.39a42.75,42.75,0,0,0-1.58,5.09c-.21-2.22-.44-4.43-.54-6.65a101.91,101.91,0,0,1,.06-13.76,102.22,102.22,0,0,0-.48,13.78c0,2.12.18,4.23.31,6.35a33,33,0,0,0-2-4.19c-1.38-2.32-3.23-4.07-5.78-3-3.15,1.29-3.42,5.66.52,7.56a15.78,15.78,0,0,0,7.42,1.41c.18,1.89.34,3.78.62,5.65.4,3,.91,6,1.5,8.91a29.42,29.42,0,0,0-2.15-3.25c-1.68-2.12-3.73-3.62-6.13-2.25-3,1.69-2.66,6.05,1.5,7.42a15.65,15.65,0,0,0,7.29.49,114.32,114.32,0,0,0,4.55,15.55l.6,1.52c-.54-.69-1.12-1.4-1.73-2-1.88-1.94-4.07-3.22-6.32-1.62-2.77,2-2,6.29,2.23,7.24a15.66,15.66,0,0,0,7.15-.21c.21.52.42,1,.67,1.55,1,2.08,1.92,4.22,3,6.27.3.59.61,1.17.92,1.75-.53-.45-1.08-.89-1.65-1.29-2.2-1.56-4.6-2.41-6.51-.41-2.34,2.46-.82,6.56,3.56,6.69a15.55,15.55,0,0,0,6.55-1.35c1.25,2.27,2.55,4.51,3.94,6.71.52.84,1.06,1.67,1.6,2.5a26.54,26.54,0,0,0-2.51-2.07c-2.21-1.56-4.61-2.41-6.51-.41-2.35,2.46-.83,6.56,3.55,6.69a15.73,15.73,0,0,0,7.22-1.66c.72,1,1.47,2,2.25,3-1.63,1.89-1.1,5.1,2.21,6.52a14.89,14.89,0,0,0,5.11,1.12c.2.17.41.33.62.48l.11.08c.77,2.88,1.61,5.74,2.49,8.58H137.2v47.11h37.16V310.77H157.05c-1.49-5.09-2.74-9.52-3-9.64l-.52-.25a17,17,0,0,0,5.35-3c3.52-3,2.52-7.19-.75-7.54-2.67-.3-4.17,1.95-5.12,4.62a23,23,0,0,0-.7,2.32c-.19-.71-.38-1.42-.56-2.13-.54-2.1-1-4.22-1.5-6.33a17.18,17.18,0,0,0,5.79-3.19c3.52-3,2.52-7.18-.75-7.54-2.67-.29-4.16,2-5.12,4.62a24.59,24.59,0,0,0-.71,2.36c-.31-1.54-.6-3.08-.87-4.63-.2-1.16-.38-2.31-.55-3.46-.07-1.64-.09-3.29-.07-4.93,0-.91,0-1.81.08-2.72a16.85,16.85,0,0,0,6.15.79c4.62-.3,6.32-4.25,3.91-6.5-2-1.82-4.51-.92-6.87.64a33.07,33.07,0,0,0-3,2.34A73.62,73.62,0,0,1,150,255.12a62.09,62.09,0,0,1,1.94-6.54,17.24,17.24,0,0,0,6.6.92c4.61-.29,6.32-4.25,3.91-6.49-2-1.83-4.51-.92-6.87.64a29.5,29.5,0,0,0-2.42,1.83,48.16,48.16,0,0,1,3.1-6.07A44.33,44.33,0,0,1,165,228.94a17.33,17.33,0,0,0,6.13,3.63c4.4,1.44,7.45-1.6,6-4.58-1.14-2.42-3.84-2.53-6.62-2a31.65,31.65,0,0,0-3.11.86l.07,0a69.71,69.71,0,0,1,12.13-7.62,17.37,17.37,0,0,0,5.66,4.79c4.11,2.12,7.61-.38,6.7-3.55-.74-2.58-3.39-3.11-6.22-3a29.91,29.91,0,0,0-3.31.37c4.57-2.16,9.23-4.2,13.73-6.58h0l.1-.05a17.39,17.39,0,0,0,7,3.65c4.49,1.11,7.31-2.15,5.68-5-1.31-2.34-4-2.24-6.74-1.46-.76.21-1.51.49-2.25.77a102.68,102.68,0,0,0,8.72-5.69l.24.25a.37.37,0,0,1,0-.11,17.49,17.49,0,0,0,7,3.7c4.49,1.1,7.31-2.15,5.69-5C220.38,200,217.68,200,215,200.82Zm-70.85,91.81c-.91-1.07-1.79-2.19-2.64-3.32.21-.19.43-.4.65-.62a15.65,15.65,0,0,0,3.9.7l0,.21.62-.12c.32,1.59.66,3.19,1,4.78A4.19,4.19,0,0,0,144.11,292.63Zm3.31-38.14c-.31,1.19-.58,2.39-.83,3.59l-.15-.21q0-3.7.11-7.39c.07-1.73.2-3.45.35-5.16a16.51,16.51,0,0,0,2.73,2.27A66.71,66.71,0,0,0,147.42,254.49Zm4.16-11.35c0-.45.1-.91.13-1.35,0-.23,0-.46,0-.68.36-.11.73-.24,1.1-.39C152.39,241.52,152,242.32,151.58,243.14Zm5.27-8.57a3.25,3.25,0,0,0-1.85-1.74c-2.5-1-4.53.82-6.14,3.14l-.08.12-.16-.05-.52-.07c0-.14.05-.28.07-.42a91.53,91.53,0,0,1,2.59-10.82,17.37,17.37,0,0,0,6.94-.54,5.93,5.93,0,0,0,3.4-2.35,15.94,15.94,0,0,0,2.5,5.68A47.91,47.91,0,0,0,156.85,234.57Z",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.66,217.26H413.43a8,8,0,0,1,8,8V350a0,0,0,0,1,0,0H227.69a0,0,0,0,1,0,0V225.23A8,8,0,0,1,235.66,217.26Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.46 408.67 198.63 408.67 227.69 349.99 421.4 349.99 450.46 408.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.42,
    y: 227.77,
    width: 170.25,
    height: 111.71,
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.46 368.56 316.8 361.41 306.56 361.41 305.88 368.56 316.46 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.62 368.56 337.27 361.41 327.03 361.41 327.04 368.56 337.62 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.71 376.21 403.65 376.21 401.08 368.56 390.51 368.56 392.71 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.88 368.56 306.56 361.41 296.33 361.41 295.31 368.56 305.88 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.73 368.56 286.09 361.41 275.86 361.41 274.15 368.56 284.73 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.93 368.56 378.21 361.41 367.98 361.41 369.35 368.56 379.93 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.51 368.56 388.45 361.41 378.21 361.41 379.93 368.56 390.51 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.15 368.56 275.86 361.41 265.62 361.41 263.57 368.56 274.15 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.19 368.56 347.5 361.41 337.27 361.41 337.62 368.56 348.19 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.08 368.56 398.68 361.41 388.45 361.41 390.51 368.56 401.08 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.35 368.56 367.98 361.41 357.74 361.41 358.77 368.56 369.35 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.77 368.56 357.74 361.41 347.5 361.41 348.19 368.56 358.77 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.04 368.56 327.03 361.41 316.8 361.41 316.46 368.56 327.04 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253 368.56 242.42 368.56 239.5 376.21 250.44 376.21 253 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.38 361.41 245.15 361.41 242.42 368.56 253 368.56 255.38 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.57 368.56 265.62 361.41 255.38 361.41 253 368.56 263.57 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.37 384.4 233 393.2 244.76 393.2 247.7 384.4 236.37 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.44 376.21 239.5 376.21 236.37 384.4 247.7 384.4 250.44 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.7 384.4 244.76 393.2 256.52 393.2 259.04 384.4 247.7 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.31 368.56 296.33 361.41 286.09 361.41 284.73 368.56 295.31 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.21 376.21 295.31 368.56 284.73 368.56 283.27 376.21 294.21 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.27 376.21 284.73 368.56 274.15 368.56 272.33 376.21 283.27 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.16 376.21 305.88 368.56 295.31 368.56 294.21 376.21 305.16 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.57 368.56 253 368.56 250.44 376.21 261.38 376.21 263.57 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.07 384.4 406.41 384.4 403.65 376.21 392.71 376.21 395.07 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.33 376.21 274.15 368.56 263.57 368.56 261.38 376.21 272.33 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.44 376.21 247.7 384.4 259.04 384.4 261.38 376.21 250.44 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.82 376.21 369.35 368.56 358.77 368.56 359.88 376.21 370.82 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.88 376.21 358.77 368.56 348.19 368.56 348.93 376.21 359.88 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.71 376.21 390.51 368.56 379.93 368.56 381.76 376.21 392.71 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.05 376.21 327.04 368.56 316.46 368.56 316.1 376.21 327.05 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.93 376.21 348.19 368.56 337.62 368.56 337.99 376.21 348.93 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.99 376.21 337.62 368.56 327.04 368.56 327.05 376.21 337.99 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.1 376.21 316.46 368.56 305.88 368.56 305.16 376.21 316.1 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.93 376.21 349.73 384.4 361.06 384.4 359.88 376.21 348.93 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.88 376.21 361.06 384.4 372.4 384.4 370.82 376.21 359.88 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.38 376.21 259.04 384.4 270.38 384.4 272.33 376.21 261.38 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.82 376.21 372.4 384.4 383.73 384.4 381.76 376.21 370.82 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.05 376.21 327.05 384.4 338.39 384.4 337.99 376.21 327.05 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.76 376.21 383.73 384.4 395.07 384.4 392.71 376.21 381.76 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.99 376.21 338.39 384.4 349.73 384.4 348.93 376.21 337.99 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.27 376.21 281.71 384.4 293.05 384.4 294.21 376.21 283.27 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.33 376.21 270.38 384.4 281.71 384.4 283.27 376.21 272.33 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.1 376.21 315.72 384.4 327.05 384.4 327.05 376.21 316.1 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.16 376.21 304.38 384.4 315.72 384.4 316.1 376.21 305.16 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.21 376.21 293.05 384.4 304.38 384.4 305.16 376.21 294.21 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.76 376.21 379.93 368.56 369.35 368.56 370.82 376.21 381.76 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.38 361.41 257.83 354.09 247.94 354.09 245.15 361.41 255.38 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.15 361.41 235.7 361.41 232.65 368.56 242.42 368.56 245.15 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.94 354.09 238.82 354.09 235.7 361.41 245.15 361.41 247.94 354.09",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.42 368.56 232.65 368.56 229.4 376.21 239.5 376.21 242.42 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.5 376.21 229.4 376.21 225.9 384.4 236.37 384.4 239.5 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.37 384.4 225.9 384.4 222.15 393.2 233 393.2 236.37 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.66 368.56 414.6 376.21 424.28 376.21 421.02 368.56 411.66 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.74 384.4 427.77 384.4 424.28 376.21 414.6 376.21 417.74 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.12 393.2 431.52 393.2 427.77 384.4 417.74 384.4 421.12 393.2",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "337.27 361.41 336.91 354.09 327.03 354.09 327.03 361.41 337.27 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.66 368.56 421.02 368.56 417.97 361.41 408.92 361.41 411.66 368.56",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.41 384.4 417.74 384.4 414.6 376.21 403.65 376.21 406.41 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.62 361.41 267.71 354.09 257.83 354.09 255.38 361.41 265.62 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.68 361.41 401.08 368.56 411.66 368.56 408.92 361.41 398.68 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.97 361.41 414.85 354.09 406.11 354.09 408.92 361.41 417.97 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.92 361.41 406.11 354.09 396.22 354.09 398.68 361.41 408.92 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 384.4 374.09 393.2 385.85 393.2 383.73 384.4 372.4 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.36 393.2 421.12 393.2 417.74 384.4 406.41 384.4 409.36 393.2",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.68 361.41 396.22 354.09 386.34 354.09 388.45 361.41 398.68 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.07 384.4 397.61 393.2 409.36 393.2 406.41 384.4 395.07 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.73 384.4 385.85 393.2 397.61 393.2 395.07 384.4 383.73 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.65 376.21 414.6 376.21 411.66 368.56 401.08 368.56 403.65 376.21",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.56 361.41 307.26 354.09 297.37 354.09 296.33 361.41 306.56 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.45 361.41 386.34 354.09 376.45 354.09 378.21 361.41 388.45 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.33 361.41 297.37 354.09 287.49 354.09 286.09 361.41 296.33 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.03 361.41 327.03 354.09 317.14 354.09 316.8 361.41 327.03 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.09 361.41 287.49 354.09 277.6 354.09 275.86 361.41 286.09 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.86 361.41 277.6 354.09 267.71 354.09 265.62 361.41 275.86 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.8 361.41 317.14 354.09 307.26 354.09 306.56 361.41 316.8 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.21 361.41 376.45 354.09 366.57 354.09 367.98 361.41 378.21 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.98 361.41 366.57 354.09 356.68 354.09 357.74 361.41 367.98 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.5 361.41 346.8 354.09 336.91 354.09 337.27 361.41 347.5 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.4 384.4 361.06 384.4 349.73 384.4 338.39 384.4 327.05 384.4 315.72 384.4 304.38 384.4 293.05 384.4 281.71 384.4 270.38 384.4 259.04 384.4 256.52 393.2 268.28 393.2 280.03 393.2 291.79 393.2 303.55 393.2 315.31 393.2 327.06 393.2 338.82 393.2 350.58 393.2 362.33 393.2 374.09 393.2 372.4 384.4",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.74 361.41 356.68 354.09 346.8 354.09 347.5 361.41 357.74 361.41",
    style: {
      fill: "#263238",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.63,
    y: 408.66,
    width: 251.94,
    height: 3.57,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "391.91 253.25 391.91 349.34 363.98 385.75 359.28 387.51 216 408.65 216 413.35 163.52 416.17 163.52 364.61 253 364.61 253 252.79 391.91 253.25",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,354.3c-6.45.32-13.44,5.24-13.44,5.24L45,416.17H163.52s74.83-56.47,77.07-58.09c3.55-2.56,10.59-3.86,10.59-3.86l-3.33.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404,
    y1: 253.34,
    x2: 245.39,
    y2: 253.34,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,219.16A11.82,11.82,0,0,0,368.25,231V376.41a12,12,0,0,1-16,11.29l-89.73-31.87a26,26,0,0,0-14.66-.82V231a11.83,11.83,0,0,1,11.83-11.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.54,359.75l78.7,27.95a12,12,0,0,0,16-11.29V359.75Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.54,359.75l78.7,27.95a12,12,0,0,0,16-11.29V359.75Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.54,378.9l78.7,28a12,12,0,0,0,16-11.3V378.9Z",
    style: {
      fill: "#FF822F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,219.16A11.82,11.82,0,0,0,368.25,231V376.41a12,12,0,0,1-16,11.29l-89.73-31.87a26,26,0,0,0-14.66-.82V231a11.83,11.83,0,0,1,11.83-11.83Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.95,
    y1: 354.3,
    x2: 247.85,
    y2: 354.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,388.41H235.87a11.92,11.92,0,0,1-4-.71l-20.79-7.31,25.85-19.9a26.17,26.17,0,0,1,25.6-4.66l89.73,31.87A11.94,11.94,0,0,0,356.27,388.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.27,388.41H235.87a11.92,11.92,0,0,1-4-.71L209.79,380l27.12-19.51a26.17,26.17,0,0,1,25.6-4.66l89.73,31.87A11.94,11.94,0,0,0,356.27,388.41Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,388.41H235.87a11.92,11.92,0,0,1-4-.71L209.79,380l27.12-19.51a26.17,26.17,0,0,1,25.6-4.66l89.73,31.87A11.94,11.94,0,0,0,356.27,388.41Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,388.41H235.87a11.92,11.92,0,0,1-4-.71l-20.79-7.31,25.85-19.9a26.17,26.17,0,0,1,25.6-4.66l89.73,31.87A11.94,11.94,0,0,0,356.27,388.41Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 235.87,
    y1: 388.41,
    x2: 235.61,
    y2: 388.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 356.5,
    y1: 388.41,
    x2: 356.27,
    y2: 388.41,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.44,222.63a11.74,11.74,0,0,0-8.36-3.47c-12.32,0-11.83,11.83-11.83,11.83v22.26h23.66V231A11.76,11.76,0,0,0,388.44,222.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.44,222.63a11.74,11.74,0,0,0-8.36-3.47c-12.32,0-11.83,11.83-11.83,11.83v22.26h23.66V231A11.76,11.76,0,0,0,388.44,222.63Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.44,222.63a11.74,11.74,0,0,0-8.36-3.47c-12.32,0-11.83,11.83-11.83,11.83v22.26h23.66V231A11.76,11.76,0,0,0,388.44,222.63Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.44,222.63a11.74,11.74,0,0,0-8.36-3.47c-12.32,0-11.83,11.83-11.83,11.83v22.26h23.66V231A11.76,11.76,0,0,0,388.44,222.63Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "258.9 239.54 258.9 239.75 258.9 244.8 258.9 245.01 258.9 250.06 258.9 250.27 258.9 255.31 258.9 255.52 258.9 260.57 258.9 260.78 258.9 265.83 258.9 266.04 258.9 271.08 258.9 271.29 258.9 276.34 258.9 276.55 258.9 281.6 258.9 281.81 258.9 286.85 258.9 287.06 258.9 292.11 258.9 292.32 258.9 297.58 270.33 297.58 270.33 292.32 270.33 292.11 270.33 287.06 270.33 286.85 270.33 281.81 270.33 281.6 270.33 276.55 270.33 276.34 270.33 271.29 270.33 271.08 270.33 266.04 270.33 265.83 270.33 260.78 270.33 260.57 270.33 255.52 270.33 255.31 270.33 250.27 270.33 250.06 270.33 245.01 270.33 244.8 270.33 239.75 270.33 239.54 270.33 234.29 258.9 234.29 258.9 239.54"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "349.02 234.29 348.78 234.29 337.84 234.29 337.59 234.29 326.65 234.29 326.4 234.29 315.47 234.29 315.22 234.29 304.28 234.29 304.03 234.29 293.1 234.29 292.85 234.29 281.91 234.29 281.66 234.29 270.48 234.29 270.48 239.75 281.66 239.75 281.91 239.75 292.85 239.75 293.1 239.75 304.03 239.75 304.28 239.75 315.22 239.75 315.47 239.75 326.4 239.75 326.65 239.75 337.59 239.75 337.84 239.75 348.78 239.75 349.02 239.75 360.21 239.75 360.21 234.29 349.02 234.29"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 239.54,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 244.8,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 250.06,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 255.31,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 260.57,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 265.83,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 271.08,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 276.34,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 281.6,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 286.85,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.9,
    y: 292.11,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.48,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.66,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.85,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.03,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.22,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.4,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.59,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.78,
    y: 234.29,
    width: 11.43,
    height: 5.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.33,
    y: 239.75,
    width: 89.87,
    height: 57.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.76,
    y1: 239.75,
    x2: 281.76,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.95,
    y1: 239.75,
    x2: 292.95,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304.14,
    y1: 239.75,
    x2: 304.14,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 315.33,
    y1: 239.75,
    x2: 315.33,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 326.51,
    y1: 239.75,
    x2: 326.51,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.7,
    y1: 239.75,
    x2: 337.7,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 348.89,
    y1: 239.75,
    x2: 348.89,
    y2: 297.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 245.01,
    x2: 360.14,
    y2: 245.01,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 250.25,
    x2: 360.14,
    y2: 250.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 255.49,
    x2: 360.14,
    y2: 255.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 260.73,
    x2: 360.14,
    y2: 260.73,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 265.97,
    x2: 360.14,
    y2: 265.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 271.2,
    x2: 360.14,
    y2: 271.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 276.44,
    x2: 360.14,
    y2: 276.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 281.68,
    x2: 360.14,
    y2: 281.68,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 286.92,
    x2: 360.14,
    y2: 286.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.33,
    y1: 292.16,
    x2: 360.14,
    y2: 292.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.04 368.38 116.69 368.38 123.34 363.33 219.69 363.33 213.04 368.38",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.7 408.92 63.34 408.92 123.34 363.33 125.71 363.33 65.7 408.92",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.81 384.48 95.47 384.48 103 378.84 199.34 378.84 191.81 384.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.38 409.15 63.03 409.15 123.34 363.33 219.69 363.33 159.38 409.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.27,
    y1: 363.5,
    x2: 73.22,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.95,
    y1: 363.5,
    x2: 82.9,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.62,
    y1: 363.5,
    x2: 92.57,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.3,
    y1: 363.5,
    x2: 102.25,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.98,
    y1: 363.5,
    x2: 111.93,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 181.66,
    y1: 363.5,
    x2: 121.6,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.33,
    y1: 363.5,
    x2: 131.28,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.01,
    y1: 363.5,
    x2: 140.96,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.69,
    y1: 363.5,
    x2: 150.63,
    y2: 409.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.79,
    y1: 372.99,
    x2: 206.85,
    y2: 372.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.12,
    y1: 378.82,
    x2: 199.18,
    y2: 378.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.45,
    y1: 384.65,
    x2: 191.51,
    y2: 384.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.78,
    y1: 390.47,
    x2: 183.84,
    y2: 390.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.11,
    y1: 396.3,
    x2: 176.17,
    y2: 396.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.44,
    y1: 402.13,
    x2: 168.5,
    y2: 402.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.81,
    y: 301.99,
    width: 101.55,
    height: 3.73,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.81,
    y: 301.99,
    width: 2.49,
    height: 48.04,
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.81,
    y: 301.99,
    width: 101.55,
    height: 48.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.51,
    y1: 302.17,
    x2: 269.51,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.71,
    y1: 302.17,
    x2: 279.71,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.91,
    y1: 302.17,
    x2: 289.91,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 300.11,
    y1: 302.17,
    x2: 300.11,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.31,
    y1: 302.17,
    x2: 310.31,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 320.51,
    y1: 302.17,
    x2: 320.51,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 330.71,
    y1: 302.17,
    x2: 330.71,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340.9,
    y1: 302.17,
    x2: 340.9,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.1,
    y1: 302.17,
    x2: 351.1,
    y2: 350.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.98,
    y1: 312.17,
    x2: 360.23,
    y2: 312.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.98,
    y1: 318.32,
    x2: 360.23,
    y2: 318.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.98,
    y1: 324.46,
    x2: 360.23,
    y2: 324.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.98,
    y1: 330.6,
    x2: 360.23,
    y2: 330.6,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.98,
    y1: 336.74,
    x2: 360.23,
    y2: 336.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.98,
    y1: 342.88,
    x2: 360.23,
    y2: 342.88,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.25px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.51,
    y: 332.81,
    width: 4.23,
    height: 9.88,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.29,
    y: 326.89,
    width: 4.23,
    height: 15.81,
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.06,
    y: 317.01,
    width: 4.23,
    height: 25.69,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.84,
    y: 326.6,
    width: 4.23,
    height: 16.09,
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.61,
    y: 317.01,
    width: 4.23,
    height: 25.69,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.19,330.82v11.74a11.74,11.74,0,0,1,0-23.48h0Z",
    style: {
      fill: "#FF822F",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.19,330.82l11.16-3.63A11.73,11.73,0,0,1,286.82,342a11.21,11.21,0,0,1-3.63.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.19,330.82V319.08a11.55,11.55,0,0,1,11.16,8.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagement);
export default __webpack_public_path__ + "static/media/management.b3eae71300fd65b4573b26d7a78fcfeb.svg";
export { ForwardRef as ReactComponent };